// data/landing.ts

import { UserRoundIcon, WrenchIcon, FileCheck2Icon } from 'lucide-react';
import type { PainPoint, DemoStep, Feature, Bonus, Testimonial, PurchaseStep, Faq } from '../types/landing';

export const site = {
  productName: 'Cotizador PRO Venezuela',
  price: '$24.99',
  checkoutUrl: 'https://digitalsolvex.shop/cart/67710253531224:1',
  whatsappUrl: 'https://wa.me/584123555747?text=Hola%2C%20tengo%20preguntas%20sobre%20Cotizador%20PRO',
  domain: 'digitalsolvex.shop',
  company: 'Digital Solvex',
};

export const painPoints: PainPoint[] = [
  { emoji: '😤', text: "El cliente dice 'ya te aviso' y nunca llama... porque otro técnico le mandó una cotización por escrito" },
  { emoji: '📝', text: 'Cotizas de memoria o en papel y a veces ni tú recuerdas cuánto cobraste' },
  { emoji: '💸', text: 'No sabes si tu precio cubre tus gastos o estás trabajando de gratis sin saberlo' },
];

export const demoSteps: DemoStep[] = [
  { icon: UserRoundIcon, title: 'Llena los datos del cliente' },
  { icon: WrenchIcon, title: 'Agrega materiales y mano de obra' },
  { icon: FileCheck2Icon, title: 'Toca el botón — PDF listo para compartir por WhatsApp' },
];

export const features: Feature[] = [
  { emoji: '⚡', title: 'Cotizaciones PDF en 2 minutos', description: 'Profesionales, con tu logo y datos de contacto' },
  { emoji: '📲', title: '100% desde tu celular', description: 'Sin computadora. Abre en Chrome desde Android o iPhone' },
  { emoji: '💱', title: 'Tasa BCV y Paralelo automática', description: 'Siempre en USD y Bs. actualizados' },
  { emoji: '📊', title: 'Dashboard de trabajos', description: 'Ve cuánto has facturado, qué está pendiente, quién te debe' },
  { emoji: '📋', title: 'Historial de cotizaciones', description: 'Nunca más pierdas un trabajo o un precio anterior' },
  { emoji: '🔧', title: 'Listo para tu oficio', description: 'Electricistas, plomeros, AC, mecánicos, técnicos de celular' },
];

export const bonuses: Bonus[] = [
  {
    label: 'BONO 1',
    emoji: '💰',
    title: 'Calculadora Tarifa Justa',
    value: '$15',
    description: 'Descubre cuánto debes cobrar POR HORA para que tu negocio sea rentable. Nunca más cobres de menos.',
  },
  {
    label: 'BONO 2',
    emoji: '💬',
    title: '12 Scripts de WhatsApp',
    value: '$22',
    description: 'Mensajes listos para enviar: cotización, seguimiento, cobro, y más. Copia, pega, listo.',
  },
  {
    label: 'BONO 3',
    emoji: '🧾',
    title: 'Recibo de Pago Profesional',
    value: '$10',
    description: 'Genera recibos PDF con sello de PAGADO automático. Da confianza y evita conflictos.',
  },
];

export const testimonials: Testimonial[] = [
  {
    initials: 'RM',
    name: 'R.M.',
    role: 'Electricista',
    city: 'Caracas',
    quote: 'Antes perdía trabajos porque el cliente se iba con otro. Ahora mando el PDF y cierran al momento.',
  },
  {
    initials: 'JP',
    name: 'J.P.',
    role: 'Técnico AC',
    city: 'Valencia',
    quote: 'La calculadora de tarifa me abrió los ojos. Estaba cobrando menos de lo que gastaba.',
  },
  {
    initials: 'MG',
    name: 'M.G.',
    role: 'Plomero',
    city: 'Barquisimeto',
    quote: 'Lo instalé en 5 minutos y ya tenía mi primera cotización PDF. Mis clientes quedaron impresionados.',
  },
];

export const purchaseSteps: PurchaseStep[] = [
  { title: 'Haz clic en el botón de compra' },
  { title: 'Paga con tarjeta, Pago Móvil o Binance Pay' },
  { title: 'Recibe el acceso inmediato por WhatsApp/email' },
  { title: 'Instala en 5 minutos y genera tu primera cotización' },
];

export const faqs: Faq[] = [
  {
    question: '¿Necesito tener conocimientos de tecnología?',
    answer: 'No. Si sabes usar WhatsApp, puedes usar esto. Es un archivo de Google Sheets con botones.',
  },
  {
    question: '¿Funciona en mi celular Android/iPhone?',
    answer: 'Sí. Se abre desde Chrome en cualquier celular. No necesitas descargar ninguna app.',
  },
  {
    question: '¿Qué pasa si no tengo internet?',
    answer: 'Necesitas internet solo para abrir el archivo y actualizar la tasa del dólar. Las cotizaciones guardadas se mantienen.',
  },
  {
    question: '¿Es una app o un programa que tengo que instalar?',
    answer: 'Es un archivo de Google Sheets. Copia el archivo a tu Drive y listo. Sin instalaciones, sin mensualidades.',
  },
  {
    question: '¿Puedo usarlo para cualquier tipo de trabajo técnico?',
    answer: 'Sí. Funciona para electricistas, plomeros, técnicos de AC, mecánicos, técnicos de celular y cualquier servicio.',
  },
];